import { useSelector } from 'react-redux';
import { RootState } from 'reducers';

import AddHubSection from './AddHubSection';
import ArchiveDiscoverItemModal from './ArchiveDiscoverItemModal';
import ChangeConversationPromptStatus from './ChangeConversationPromptStatus';
import ConfirmationModal from './ConfirmationModal';
import SwitchOrganizations from './SwitchOrganizations';
import ThryveAdminNewTemplateType from './ThryveAdminNewTemplateType';
import UnarchiveDiscoverItemModal from './UnarchiveDiscoverItemModal';
import Video from './Video';

export type ModalTypes =
  | 'AddHubSection'
  | 'ArchiveDiscoverItemModal'
  | 'ChangeConversationPromptStatus'
  | 'Confirmation'
  | 'SwitchOrganizations'
  | 'ThryveAdminNewTemplateType'
  | 'UnarchiveDiscoverItemModal'
  | 'Video';

function ModalHandler() {
  const { modalType, props } = useSelector(({ modal }: RootState) => modal);

  switch (modalType) {
    case 'AddHubSection':
      return <AddHubSection {...props} />;
    case 'ArchiveDiscoverItemModal':
      return <ArchiveDiscoverItemModal {...props} />;
    case 'ChangeConversationPromptStatus':
      return <ChangeConversationPromptStatus {...props} />;
    case 'Confirmation':
      return <ConfirmationModal {...props} />;
    case 'SwitchOrganizations':
      return <SwitchOrganizations {...props} />;
    case 'ThryveAdminNewTemplateType':
      return <ThryveAdminNewTemplateType {...props} />;
    case 'UnarchiveDiscoverItemModal':
      return <UnarchiveDiscoverItemModal {...props} />;
    case 'Video':
      return <Video {...props} />;
    default:
      return null;
  }
}
export default ModalHandler;
